// Trustpilot Score en Reviews Extractor uit Specifieke HTML
(function () {
    // Variabele om bij te houden of de injectie al is uitgevoerd
    let injectionPerformed = false;

    // Functie om score en aantal reviews uit de specifieke HTML structuur te halen
    function extractTrustpilotData() {
        // Zoek de specifieke div met Trustpilot informatie
        const trustpilotElement = document.querySelector('#CustomReviewSlider_Col1 .TP-text p');

        if (!trustpilotElement) {
            console.warn('Trustpilot element niet gevonden');
            return { score: "0", reviewsCount: "0" };
        }

        const text = trustpilotElement.textContent.trim();
        console.log('Gevonden Trustpilot tekst:', text);

        // Regex om score en aantal reviews te extraheren
        // Zoekt naar patronen zoals "4,7/5" en "1540 beoordelingen"
        const scoreRegex = /(\d+[,\.]\d+)\/5/;
        const reviewsRegex = /meer dan (\d+) beoordelingen/;

        let score = "0";
        let reviewsCount = "0";

        // Score extraheren
        const scoreMatch = text.match(scoreRegex);
        if (scoreMatch && scoreMatch[1]) {
            // Vervang komma door punt voor internationale notatie
            score = scoreMatch[1].replace(',', '.');
        }

        // Aantal reviews extraheren
        const reviewsMatch = text.match(reviewsRegex);
        if (reviewsMatch && reviewsMatch[1]) {
            reviewsCount = reviewsMatch[1];
        }

        console.log('Geëxtraheerde waarden:', { score, reviewsCount });
        return { score, reviewsCount };
    }

    // Functie om de score VOOR het product element te injecteren
    function injectTrustScore(score, reviewsCount) {
        // Als de injectie al is uitgevoerd, doe niets
        if (injectionPerformed) {
            return;
        }

        // Controleer of er al een trust-score-container bestaat
        if (document.querySelector('.trust-score-container')) {
            console.log('Trustpilot score is al geïnjecteerd');
            injectionPerformed = true;
            return;
        }

        const productElement = document.querySelector('.product-123');

        if (productElement) {
            const trustScoreDiv = document.createElement('div');
            trustScoreDiv.className = 'trust-score-container';

            // HTML samenstellen met de afbeeldingen in een aparte div
            trustScoreDiv.innerHTML = `
                <div class="trust-images-container">
                    <img class="trustpilot-logo" src="https://cdn.shopify.com/s/files/1/0759/0379/5515/files/trustpilot2525-removebg-preview.png?v=1709682595">
                    <img class="trustpilot-stars" src="https://cdn.trustpilot.net/brand-assets/4.1.0/stars/stars-5.svg">
                </div>
                <div class="trust-score-text">
                    Trustscore <strong>${score}</strong> | ${reviewsCount} reviews
                </div>
            `;

            // Injecteren VOOR het product element
            productElement.insertAdjacentElement('beforebegin', trustScoreDiv);
            console.log('Trustpilot score succesvol geïnjecteerd voor het product element');

            // Markeer dat de injectie is uitgevoerd
            injectionPerformed = true;
        } else {
            console.warn('Geen element met klasse "product" gevonden om de Trustpilot score voor te injecteren');
        }
    }

    // Functie om de injectie te starten
    function initTrustpilotInjection() {
        if (!injectionPerformed) {
            const data = extractTrustpilotData();
            injectTrustScore(data.score, data.reviewsCount);
        }
    }

    // Event listener voor DOMContentLoaded
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initTrustpilotInjection);
    } else {
        // Voor pagina's die al geladen zijn
        initTrustpilotInjection();
    }
})();

function calculateHMSleft() {
 const now = new Date();
 const hoursleft = 23 - now.getHours();
 const minutesleft = 59 - now.getMinutes();
 const secondsleft = 59 - now.getSeconds();
 const totalSecondsLeft = hoursleft * 3600 + minutesleft * 60 + secondsleft;
 const remainingTime = formatTime(totalSecondsLeft);
 updateElements(remainingTime);
}

function formatTime(totalSecondsLeft) {
 if (totalSecondsLeft >= 86400) return "meer dan 1 dag";
 
 const hours = Math.floor(totalSecondsLeft / 3600);
 const minutes = Math.floor((totalSecondsLeft % 3600) / 60);
 const seconds = totalSecondsLeft % 60;
 
 let timeString = '';
 if (hours > 0) timeString += `${hours}u `;
 if (minutes > 0 || hours > 0) timeString += `${minutes}m `;
 timeString += `${seconds}s`;
 
 return timeString;
}

function updateElements(remainingTime) {
 document.querySelectorAll("#HMSremaining").forEach(element => {
   const existingContent = element.innerHTML;
   const parentDiv = element.closest('.voorraadmelding');
   
   if (!parentDiv) return;
   
   const meldingClass = Array.from(parentDiv.classList).find(className => className.startsWith('voorraadmelding-'));
   if (!meldingClass) return;
   
   const meldingNumber = parseInt(meldingClass.split('-')[1]);
   
   if ([4, 5].includes(meldingNumber)) {
     element.innerHTML = remainingTime;
   } else {
     if (!existingContent.includes("Bestel in de komende")) {
       element.innerHTML = `${existingContent}Bestel in de komende <strong>${remainingTime}</strong> en je bestelling wordt <strong>vandaag verzonden</strong>.`;
     } else {
       element.querySelector("strong").innerHTML = remainingTime;
     }
   }
 });
}

function handleStockReminders() {
 document.querySelectorAll("#stock-reminder").forEach(stockReminder => {
   const sqzlyElement = stockReminder.closest(".sqzly-320");
   if (sqzlyElement) {
     const observer = new MutationObserver(() => {
       sqzlyElement.style.display = stockReminder.classList.contains("d-none") ? "" : "none";
     });
     
     observer.observe(stockReminder, { attributes: true });
     sqzlyElement.style.display = stockReminder.classList.contains("d-none") ? "" : "none";
   }
 });
}

calculateHMSleft();
setInterval(calculateHMSleft, 1000);
handleStockReminders();

const selects = document.querySelectorAll("#simple-bundles-io-options select");

    selects.forEach(select => {
        // Selecteer alle opties binnen de huidige select
        const options = select.querySelectorAll("option");

        options.forEach(option => {
            // Controleer of de optie een inventory van 0 heeft en verwijder deze
            if (option.dataset.inventory === "0") {
                option.remove();
            }
        });
    });